import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

const deleteComponent = async (componentId: string): Promise<void> => {
  await customAxios.delete(`/components/${componentId}`);
};

export const useDeleteComponent = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteComponent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['components', orgId] }).catch(() => undefined);
    },
  });
};
